import React from "react";

/**
 * Per-cell validation error flag for Running Total grid inputs.
 * Set in GridRenderer VariableCell; undefined outside that subtree.
 */
export const GridCellValidationErrorContext = React.createContext<boolean | undefined>(undefined);

export function useGridCellValidationError(): boolean | undefined {
    return React.useContext(GridCellValidationErrorContext);
}
